import React, { useState, useEffect } from "react";
import { matchPath } from "react-router-dom";
import PropTypes from "prop-types";
import Cookie from "js-cookie";

import IsEmpty from "../helpers/IsEmpty";
import Sidebar from "./Sidebar/Sidebar";

import AppRoutePath from "../../router/AppRoutePath";
import Navbar from "./Navbar";
import { getUserAuthorizations } from "./authorization/Authorization";
import { ContextProvider } from "./authorization/MyContext";
import { AxiosCustomGet, AxiosCustomPut } from "../axios/AxiosCustom";
import Config from "../axios/Config";
import Cookies from "js-cookie";
import Notifications from "./notification/Notification";

const Template = ({ children }) => {
  const [userAuthorizations, setUserAuthorizations] = useState({});
  const [dataNotification, setDataNotification] = useState([]);
  const [totalNotif, setTotalNotif] = useState();
  const [selectedNotif, setSelectedNotif] = useState([]);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState();
  const [hasMore, setHasMore] = useState(true);

  const getUserAuthorization = async () => {
    let user_authorizations = await getUserAuthorizations();
    setUserAuthorizations(user_authorizations);
  };

  useEffect(() => {
    getUserAuthorization();
  }, []);

  useEffect(() => {
    getDataNotification();
  }, [size]);

  const getDataNotification = () => {
    const url = `${
      process.env.REACT_APP_BASE_API_URL
    }self/notifications?size=${size}&page=${1}`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        let data = response.data.data;
        setDataNotification(data.items);
        setTotalNotif(data.total_item);
        setPage(page);
        setLastPage(data.last_page);
      }
    );
  };

  const getMoreNotification = () => {
    let next_page = page + 1;
    if (next_page > lastPage) {
      setHasMore(false);
      return false;
    } else {
      setHasMore(true);
      const url = `${process.env.REACT_APP_BASE_API_URL}self/notifications?size=${size}&page=${next_page}`;
      AxiosCustomGet(
        url,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        (response) => {
          let data = response.data.data;

          const newList = dataNotification.concat(data.items);
          setDataNotification(newList);
          setPage(next_page);
        }
      );
    }
  };

  const handleSelectNotif = (item) => {
    let selectedArray = selectedNotif.filter((e) => e !== item.id);

    if (!selectedNotif.includes(item.id)) {
      setSelectedNotif((prev) => [...prev, item.id]);
    } else {
      setSelectedNotif(selectedArray);
    }

    let notifArray = dataNotification;
    let foundIndex = dataNotification.findIndex((x) => x.id == item.id);
    notifArray[foundIndex] = {
      ...notifArray[foundIndex],
      selected: item.selected ? false : true,
    };
    setDataNotification(notifArray);
  };

  const markAsRead = () => {
    let data = {
      notification_ids: selectedNotif,
    };
    const url = `${process.env.REACT_APP_BASE_API_URL}self/notifications/mark-read`;
    AxiosCustomPut(
      url,
      data,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        getDataNotification();
        setSelectedNotif([]);
      }
    );
  };

  async function handleButtonFooterNotification() {
    // if (selectedNotif.length > 0) {
    markAsRead();
    // } else {
    //   setSize(null);
    // }
  }

  if (
    IsEmpty(Cookie.get("access_token")) &&
    IsEmpty(Cookie.get("refresh_token")) &&
    !matchPath(window.location.pathname, AppRoutePath.LOGIN)
  ) {
    window.location.href = AppRoutePath.LOGIN;
  } else {
    return (
      <ContextProvider
        value={{
          user_authorizations: userAuthorizations,
        }}
      >
        <div>
          <div className="d-flex" id="wrapper">
            <Sidebar />
            <div className="ohana-container">
              <Navbar
                dataNotification={dataNotification}
                setSize={setSize}
                totalNotif={totalNotif}
                handleSelectNotif={handleSelectNotif}
                handleButtonFooterNotification={handleButtonFooterNotification}
                selectedNotif={selectedNotif}
                getMoreNotification={getMoreNotification}
                hasMore={hasMore}
                getDataNotification={getDataNotification}
              />
              {children}
              <Notifications />
            </div>
          </div>
        </div>
      </ContextProvider>
    );
  }
};

Template.propTypes = {
  withPadding: PropTypes.bool,
  withFooter: PropTypes.bool,
};
Template.defaultProps = {
  withPadding: true,
  withFooter: true,
};

export default Template;
